<script lang="ts">
    import Button from "../materialize/components/Button.svelte";
    import Icon from "../materialize/components/Icon.svelte";
    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();

    let is_playing: boolean = false;
    export let audio_path: string;
    let audio_player: HTMLAudioElement = new Audio(audio_path);
    audio_player.addEventListener("ended", ()=>{
        dispatch('ended', {});
    })
    function play() {
        audio_player.play();
    }

    export let class_list: string[] = [];
    export let size;
</script>

{#if audio_path}
    <Button
        {size}
        on:click
        class_list={class_list.concat(["approu-primary"])}
        on:click={play}>
        
        <Icon icon="audiotrack" />
        <Icon icon="play_arrow" />
        </Button
    >
{/if}

<style>
</style>
